import {
    CREATE_PROCESS_COST_PER_PCS_REQUEST,
    CREATE_PROCESS_COST_PER_PCS_SUCCESS,
    CREATE_PROCESS_COST_PER_PCS_FAILURE,
    DELETE_PROCESS_COST_PER_PCS_REQUEST,
    DELETE_PROCESS_COST_PER_PCS_SUCCESS,
    DELETE_PROCESS_COST_PER_PCS_FAILURE,
    FETCH_SINGLE_PROCESS_COST_PER_PCS_REQUEST,
    FETCH_SINGLE_PROCESS_COST_PER_PCS_SUCCESS,
    FETCH_SINGLE_PROCESS_COST_PER_PCS_FAILURE,
    FETCH_PROCESS_COST_PER_PCS_REQUEST,
    FETCH_PROCESS_COST_PER_PCS_SUCCESS,
    FETCH_PROCESS_COST_PER_PCS_FAILURE,
    UPDATE_PROCESS_COST_PER_PCS_REQUEST,
    UPDATE_PROCESS_COST_PER_PCS_SUCCESS,
    UPDATE_PROCESS_COST_PER_PCS_FAILURE,
    RESET_PROCESS_COST_PER_PCS_INFO,
    CREATE_PROCESS_COST_PER_PCS_FORM,
    UPDATE_PROCESS_COST_PER_PCS_FORM,
    FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_FAILURE,
    RESET_PROCESS_COST_PER_PCS_BY_STYLE_DATA,
    ASSIGN_PROCESS_TOGGLE_PCS,
    CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_REQUEST,
    CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_SUCCESS,
    CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_FAILURE,
    FETCH_PROCESS_COST_PER_PCS_INVOICE_REQUEST,
    FETCH_PROCESS_COST_PER_PCS_INVOICE_SUCCESS,
    FETCH_PROCESS_COST_PER_PCS_INVOICE_FAILURE,
    RESET_PROCESS_COST_PER_PCS_INVOICE,
    FETCH_RATE_PER_PCS_INVOICE_DATA_REQUEST,
    FETCH_RATE_PER_PCS_INVOICE_DATA_SUCCESS,
    FETCH_RATE_PER_PCS_INVOICE_DATA_FAILURE
} from './processCostPerPcs.actionsType';

export const PROCESS_COST_PER_PCS = 'processCostPerPcs';

let initialState = {
    loading: false,
    processCostPerPcsList: [],
    processCostPerPcsListByStyle: [],
    processCostPerPcsForm: {
        fldIncreasingRate: '',
        fldDecreasingRate: '',
        fldMidValue: '',
        FldIsVerified: false
    },
    assignProcessModal: false,
    selectedState: {},
    responseStatusCostPerPcs: '',
    errorMessage: '',
    checkPcsProcessIdData: [],
    processcostperpcsInvoice: [],
    ratePerPcsInvoiceData: 0
};

export let processCostPerPcsReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_PROCESS_COST_PER_PCS_REQUEST:
        case FETCH_RATE_PER_PCS_INVOICE_DATA_REQUEST:
        case CREATE_PROCESS_COST_PER_PCS_REQUEST:
        case UPDATE_PROCESS_COST_PER_PCS_REQUEST:
        case FETCH_SINGLE_PROCESS_COST_PER_PCS_REQUEST:
        case FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_REQUEST:
        case DELETE_PROCESS_COST_PER_PCS_REQUEST:
        case CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_REQUEST:
        case FETCH_PROCESS_COST_PER_PCS_INVOICE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_COST_PER_PCS_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerPcsList: updatePayload
            };
        case FETCH_RATE_PER_PCS_INVOICE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                ratePerPcsInvoiceData: updatePayload && updatePayload.toFixed(2)
            };
        case FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerPcsListByStyle: updatePayload
            };
        case CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                checkPcsProcessIdData: updatePayload
            };
        case CREATE_PROCESS_COST_PER_PCS_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerPcsListByStyle: [],
                processCostPerPcsForm: { fldIncreasingRate: '', fldDecreasingRate: '', fldMidValue: '', FldIsVerified: false }
            };
        case UPDATE_PROCESS_COST_PER_PCS_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerPcsForm: { fldIncreasingRate: '', fldDecreasingRate: '', fldMidValue: '', FldIsVerified: false },
                processCostPerPcsListByStyle: [],
                responseStatusCostPerPcs: updatePayload
            };
        case FETCH_SINGLE_PROCESS_COST_PER_PCS_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerPcsForm: {
                    fldId: updatePayload[0].FldcombineID,
                    fldFKProcessFlow: updatePayload[0].FldFKProcessFlow,
                    fldFKStyle: updatePayload[0].FldFKSize,
                    FldIsVerified: updatePayload[0].FldIsVerified,
                    fldPriceType: updatePayload[0].FldPriceType,
                    fldIncreasingRate: updatePayload[0].FldIncreasingRate,
                    fldDecreasingRate: updatePayload[0].FldDecreasingRate,
                    fldMidValue: updatePayload[0].FldMidValue,
                    fldCost01: updatePayload[0].FldCost01,
                    fldCost02: updatePayload[0].FldCost02,
                    fldCost03: updatePayload[0].FldCost03,
                    fldCost04: updatePayload[0].FldCost04,
                    fldCost05: updatePayload[0].FldCost05,
                    fldCost06: updatePayload[0].FldCost06,
                    fldCost07: updatePayload[0].FldCost07,
                    fldCost08: updatePayload[0].FldCost08,
                    fldCost09: updatePayload[0].FldCost09,
                    fldCost10: updatePayload[0].FldCost10,
                    fldCost11: updatePayload[0].FldCost11,
                    fldCost12: updatePayload[0].FldCost12,
                    fldCost13: updatePayload[0].FldCost13,
                    fldCost14: updatePayload[0].FldCost14,
                    fldCost15: updatePayload[0].FldCost15,
                    fldCost16: updatePayload[0].FldCost16,
                    fldCost17: updatePayload[0].FldCost17,
                    fldCost18: updatePayload[0].FldCost18,
                    fldS01: updatePayload[0].FldS01,
                    fldS02: updatePayload[0].FldS02,
                    fldS03: updatePayload[0].FldS03,
                    fldS04: updatePayload[0].FldS04,
                    fldS05: updatePayload[0].FldS05,
                    fldS06: updatePayload[0].FldS06,
                    fldS07: updatePayload[0].FldS07,
                    fldS08: updatePayload[0].FldS08,
                    fldS09: updatePayload[0].FldS09,
                    fldS10: updatePayload[0].FldS10,
                    fldS11: updatePayload[0].FldS11,
                    fldS12: updatePayload[0].FldS12,
                    fldS13: updatePayload[0].FldS13,
                    fldS14: updatePayload[0].FldS14,
                    fldS15: updatePayload[0].FldS15,
                    fldS16: updatePayload[0].FldS16,
                    fldS17: updatePayload[0].FldS17,
                    fldS18: updatePayload[0].FldS18
                }
            };
        case DELETE_PROCESS_COST_PER_PCS_SUCCESS:
            return {
                ...state,
                loading: false,
                processCostPerPcsForm: { fldIncreasingRate: '', fldDecreasingRate: '', fldMidValue: '', FldIsVerified: false },
                processCostPerPcsListByStyle: []
            };
        case FETCH_PROCESS_COST_PER_PCS_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                processcostperpcsInvoice: updatePayload
            };
        case RESET_PROCESS_COST_PER_PCS_INVOICE:
            return {
                ...state,
                processcostperpcsInvoice: []
            };
        case RESET_PROCESS_COST_PER_PCS_INFO:
            return {
                ...state,
                processCostPerPcsForm: { fldIncreasingRate: '', fldDecreasingRate: '', fldMidValue: '', FldIsVerified: false, fldFKProcessFlow: '', fldPriceType: '' }
            };
        case CREATE_PROCESS_COST_PER_PCS_FORM:
        case UPDATE_PROCESS_COST_PER_PCS_FORM:
            return {
                ...state,
                loading: false,
                processCostPerPcsForm: {
                    ...state.processCostPerPcsForm,
                    [payload.key]: payload.value
                }
            };
        case UPDATE_PROCESS_COST_PER_PCS_FAILURE:
            return {
                ...state,
                loading: false,
                responseStatusCostPerPcs: updatePayload?.status
            };
        case FETCH_PROCESS_COST_PER_PCS_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                processCostPerPcsListByStyle: [],
                ...state,
                loading: false
            };
        case RESET_PROCESS_COST_PER_PCS_BY_STYLE_DATA:
            return {
                ...state,
                loading: false,
                processCostPerPcsListByStyle: []
            };
        case FETCH_PROCESS_COST_PER_PCS_FAILURE:
        case FETCH_RATE_PER_PCS_INVOICE_DATA_FAILURE:
        case CREATE_PROCESS_COST_PER_PCS_FAILURE:
        case FETCH_SINGLE_PROCESS_COST_PER_PCS_FAILURE:
        case DELETE_PROCESS_COST_PER_PCS_FAILURE:
        case CHECK_PROCESS_COST_PER_PCS_PROCESS_ID_FAILURE:
        case FETCH_PROCESS_COST_PER_PCS_INVOICE_FAILURE:
            return {
                ...state,
                loading: false
            };
        case ASSIGN_PROCESS_TOGGLE_PCS:
            return {
                ...state,
                assignProcessModal: payload
            };
        default:
            return state;
    }
};
